import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Address, RequestService } from 'clicklease-ui-elements';
import { environment } from '@envs/environment';
import {
    BankAccountData,
    UpdateSuccess,
    Contract,
    RoseLogged,
    UserData,
    WritableBusinessInformation,
    WritablePersonalInformation,
    BaseBankAccount,
    PaymentLink,
    RoseCustomersResponse,
} from './../../interfaces';

@Injectable({
    providedIn: 'root',
})
export class RoseService extends RequestService {
    protected readonly serviceBaseUrl: string = `${environment.API_URL}roses/`;

    public getBankInformation(roseKey: string): Observable<BankAccountData[]> {
        return this.get<BankAccountData[]>({
            url: `${roseKey}/bankinformation`,
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }

    public getLeases(roseKey: string): Observable<Contract[]> {
        return this.get<Contract[]>({
            url: `${roseKey}/leases`,
            headers: {
                'content-type': 'application/json',
            },
        });
    }

    public getPaymentLink(roseKey: string, leaseKey: string): Observable<PaymentLink> {
        return this.get<PaymentLink>({
            url: `${roseKey}/leases/${leaseKey}/paymentLink`,
            headers: {
                'content-type': 'application/json',
            },
        });
    }

    public getRoseData(roseKey: string): Observable<RoseLogged> {
        return this.get<RoseLogged>({
            url: roseKey,
            headers: {
                'content-type': 'application/json',
            },
        });
    }

    public updateBankInformation(
        roseKey: string,
        params: BaseBankAccount
    ): Observable<UpdateSuccess> {
        return this.post<UpdateSuccess>({
            url: `${roseKey}/bankinformation`,
            headers: {
                'Content-Type': 'application/json',
            },
            params,
        });
    }

    public updateBusinessInfo(
        roseKey: string,
        businessKey: string,
        params: WritableBusinessInformation
    ): Observable<UpdateSuccess> {
        return this.put<UpdateSuccess>({
            url: `${roseKey}/businessInformation/${businessKey}`,
            params,
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }

    public updateEquipmentLocation(
        roseKey: string,
        params: Address
    ): Observable<UpdateSuccess> {
        return this.put<UpdateSuccess>({
            url: `${roseKey}/equipmentLocation`,
            params,
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }

    public updatePersonalInfo(
        roseKey: string,
        params: WritablePersonalInformation
    ): Observable<UpdateSuccess> {
        return this.put<UpdateSuccess>({
            url: `${roseKey}/personalInformation`,
            params,
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }

    public getCustomers(filterText: string): Observable<RoseCustomersResponse> {
        return this.post<RoseCustomersResponse>({
            url: `search`,
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                filterText
            }
        });
    }

    public setLastLogin(roseKey: string): Observable<void> {
        return this.put<void>({
            url: `${roseKey}/last-login`,
            headers: {
                'Content-Type': 'application/json',
            }
        });
    }
}
